<template>
  <div>
    <!-- Diálogo Principal -->
    <v-dialog
      v-model="dialog"
      persistent
      max-width="720px"
      @click:outside="cerrarDialogo(false)"
    >
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="agregar()"
      >
        <v-card class="rounded-lg elevation-3 overflow-hidden">
          <!-- Toolbar Header Principal estilo Inspección -->
          <!-- Toolbar Header Principal -->
          <v-toolbar
            color="secondary"
            dark
            flat
            class="table-header-toolbar px-2 px-sm-4"
          >
            <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
              <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
                <v-icon color="white">{{
                  isNuevo ? "mdi-layers-plus" : "mdi-layers-edit"
                }}</v-icon>
              </div>
              <div class="header-text-block min-width-0 mr-2 mr-sm-3">
                <div class="header-company-title font-weight-bold text-truncate">
                  {{
                    isNuevo
                      ? "Nueva Configuración de Aplicación"
                      : "Editar Configuración de Aplicación"
                  }}
                </div>
              </div>
              <v-chip
                v-if="!isNuevo && Item.id"
                small
                color="white"
                text-color="secondary"
                class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
              >
                <v-icon left size="15" color="secondary">mdi-pound</v-icon>
                ID: {{ Item.id }}
              </v-chip>
            </div>

            <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
              <v-btn
                icon
                dark
                @click="cerrarDialogo(false)"
                class="btn-circle-tooltip"
              >
                <v-icon size="20">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-toolbar>

          <v-card-text class="pa-3 pa-sm-4 pa-md-5">
            <!-- SECCIÓN 1: APLICACIÓN -->
            <div class="section-title d-flex align-center mb-3">
              <v-icon color="secondary" small class="mr-2"
                >mdi-tag-outline</v-icon
              >
              <span class="text-subtitle-2 font-weight-bold text--primary">
                Identificación de la Aplicación
              </span>
            </div>

            <v-row dense class="mb-3">
              <v-col cols="12" class="pa-2">
                <v-autocomplete
                  :items="ItemsAplicacion"
                  v-model="Item.aplicacion"
                  item-text="aplicacion"
                  item-value="id"
                  label="Seleccionar Aplicación *"
                  placeholder="Seleccione o busque una aplicación..."
                  :rules="[(v) => !!v || 'La aplicación es requerida']"
                  dense
                  outlined
                  prepend-inner-icon="mdi-layers"
                  class="rounded-lg"
                  hide-details="auto"
                >
                  <template v-slot:append-outer>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          elevation="1"
                          class="rounded-lg btn-append-action mt-n1"
                          @click="abrirdialogapli"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon size="22">mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Registrar nuevo nombre de aplicación</span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>

            <!-- SECCIÓN 2: LÍMITES DE REENCAUCHE -->
            <div class="section-title d-flex align-center mb-3 mt-2">
              <v-icon color="secondary" small class="mr-2"
                >mdi-ruler-square</v-icon
              >
              <span class="text-subtitle-2 font-weight-bold text--primary">
                Umbrales de Reencauche (mm)
              </span>
            </div>

            <v-alert
              dense
              text
              type="info"
              icon="mdi-information-outline"
              class="rounded-lg mb-4 text-caption"
            >
              Defina los valores milimétricos que delimitan el inicio y límite
              tanto del reencauche como del estado próximo a reencauchar.
            </v-alert>

            <v-row dense class="mb-3">
              <!-- Inicio Reencauche -->
              <v-col cols="12" sm="6" class="pa-2">
                <v-text-field
                  type="number"
                  step="any"
                  @input="validarreglas"
                  label="Inicio de Reencauche (mm) *"
                  placeholder="Ej: 3"
                  hide-details="auto"
                  v-model="Item.ini_reencauche"
                  outlined
                  dense
                  prepend-inner-icon="mdi-arrow-collapse-down"
                  class="rounded-lg"
                  :rules="[
                    (v) => !!v || 'Campo requerido',
                    (v) =>
                      /^[0-9]+(\.[0-9]+)?$/.test(v) ||
                      'No se permiten números negativos',
                  ]"
                ></v-text-field>
              </v-col>

              <!-- Límite Reencauche -->
              <v-col cols="12" sm="6" class="pa-2">
                <v-text-field
                  type="number"
                  step="any"
                  label="Límite de Reencauche (mm) *"
                  placeholder="Ej: 5"
                  hide-details="auto"
                  v-model="Item.reencauche"
                  outlined
                  dense
                  prepend-inner-icon="mdi-arrow-collapse-up"
                  class="rounded-lg"
                  @input="dariniproxreen"
                  @change="validarreglas"
                  :rules="[
                    (v) => !!v || 'Campo requerido',
                    (v) =>
                      /^[0-9]+(\.[0-9]+)?$/.test(v) ||
                      'No se permiten números negativos',
                    (v) =>
                      parseFloat(v) > parseFloat(Item.ini_reencauche) ||
                      'Debe ser mayor que el Inicio de reencauche',
                  ]"
                ></v-text-field>
              </v-col>

              <!-- Inicio Próximo Reencauche -->
              <v-col cols="12" sm="6" class="pa-2">
                <v-text-field
                  type="number"
                  step="any"
                  @input="validarreglas"
                  label="Inicio de Próx. a Reencauchar (mm) *"
                  placeholder="Ej: 6"
                  hide-details="auto"
                  v-model="Item.ini_prox_reencauche"
                  outlined
                  dense
                  prepend-inner-icon="mdi-arrow-expand-down"
                  class="rounded-lg"
                  :rules="[
                    (v) => !!v || 'Campo requerido',
                    (v) =>
                      /^[0-9]+(\.[0-9]+)?$/.test(v) ||
                      'No se permiten números negativos',
                    (v) =>
                      parseFloat(v) > parseFloat(Item.reencauche) ||
                      'Debe ser mayor que el Límite de reencauche',
                  ]"
                ></v-text-field>
              </v-col>

              <!-- Límite Próximo Reencauche -->
              <v-col cols="12" sm="6" class="pa-2">
                <v-text-field
                  type="number"
                  step="any"
                  @input="validarreglas"
                  label="Límite de Próx. a Reencauchar (mm) *"
                  placeholder="Ej: 8"
                  hide-details="auto"
                  v-model="Item.prox_reencauche"
                  outlined
                  dense
                  prepend-inner-icon="mdi-arrow-expand-up"
                  class="rounded-lg"
                  :rules="[
                    (v) => !!v || 'Campo requerido',
                    (v) =>
                      /^[0-9]+(\.[0-9]+)?$/.test(v) ||
                      'No se permiten números negativos',
                    (v) =>
                      parseFloat(v) > parseFloat(Item.ini_prox_reencauche) ||
                      'Debe ser mayor que el Inicio del Próximo reencauche',
                  ]"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- SECCIÓN 3: DESGASTE IRREGULAR -->
            <div class="section-title d-flex align-center mb-3 mt-2">
              <v-icon color="secondary" small class="mr-2"
                >mdi-chart-bell-curve</v-icon
              >
              <span class="text-subtitle-2 font-weight-bold text--primary">
                Parámetros de Desgaste Irregular
              </span>
            </div>

            <v-row dense>
              <!-- Desgaste Irregular 1 -->
              <v-col cols="12" sm="6" class="pa-2">
                <v-text-field
                  type="number"
                  step="any"
                  @input="darvalordesg_irre_2"
                  label="Desgaste Irregular 1 *"
                  placeholder="Ej: 2"
                  hide-details="auto"
                  v-model="Item.desg_irregular_1"
                  outlined
                  dense
                  prepend-inner-icon="mdi-numeric-1-circle-outline"
                  class="rounded-lg"
                  :rules="[(v) => !!v || 'Campo requerido']"
                ></v-text-field>
              </v-col>

              <!-- Desgaste Irregular 2 -->
              <v-col cols="12" sm="6" class="pa-2">
                <v-text-field
                  type="number"
                  step="any"
                  label="Desgaste Irregular 2 *"
                  placeholder="Ej: -2"
                  hide-details="auto"
                  v-model="Item.desg_irregular_2"
                  outlined
                  dense
                  prepend-inner-icon="mdi-numeric-2-circle-outline"
                  class="rounded-lg"
                  :rules="[(v) => !!v || 'Campo requerido']"
                ></v-text-field>
              </v-col>
            </v-row>

            <div class="d-flex align-center mt-3 text-caption text--secondary">
              <v-icon x-small color="error" class="mr-1">mdi-asterisk</v-icon>
              <span>Campos obligatorios</span>
            </div>
          </v-card-text>

          <!-- Botones de Acción / Footer -->
          <v-card-actions
            class="pa-3 pa-sm-4 bg-light border-top d-flex align-center form-card-actions"
          >
            <v-spacer class="d-none d-sm-flex"></v-spacer>
            <v-btn
              outlined
              color="grey darken-1"
              class="btn-form-action text-capitalize px-4 rounded-lg mr-sm-2 font-weight-medium"
              @click="cerrarDialogo(false)"
            >
              <v-icon left small>mdi-close</v-icon>
              Cancelar
            </v-btn>

            <v-btn
              color="primary"
              elevation="2"
              class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
              :loading="loading"
              :disabled="loading || !valid"
              @click="agregar()"
            >
              <v-icon left small>{{
                isNuevo ? "mdi-content-save" : "mdi-pencil"
              }}</v-icon>
              {{ isNuevo ? "Guardar Aplicación" : "Actualizar Aplicación" }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Diálogo Secundario: Crear Nueva Aplicación (Nombre) -->
    <v-dialog
      v-model="dialogaplicacion"
      persistent
      max-width="420px"
      @click:outside="cerrardialogapli"
      v-if="modal_aplicacion"
    >
      <v-form
        ref="formaplicacion"
        lazy-validation
        @submit.prevent="addAplicacion()"
      >
        <v-card class="rounded-lg elevation-3 overflow-hidden">
          <v-toolbar height="50" color="secondary" dark flat class="px-3">
            <v-icon left size="20">mdi-tag-plus</v-icon>
            <span class="text-subtitle-1 font-weight-medium">
              Nueva Aplicación
            </span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              dark
              small
              @click="cerrardialogapli"
              class="btn-circle-tooltip"
            >
              <v-icon size="18">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pa-4">
            <v-text-field
              label="Nombre de la Aplicación *"
              placeholder="Ej: Mina, Carretera, Urbano..."
              hide-details="auto"
              required
              v-model="aplicacion"
              outlined
              dense
              prepend-inner-icon="mdi-tag-outline"
              class="rounded-lg"
              :rules="[(v) => !!v || 'El nombre es requerido']"
            ></v-text-field>

            <v-alert
              v-if="mostrarLabelDuplicado"
              dense
              text
              type="error"
              icon="mdi-alert-circle"
              class="rounded-lg mt-3 mb-0 text-caption"
            >
              Esta aplicación ya se encuentra registrada.
            </v-alert>
          </v-card-text>

          <v-card-actions class="pa-3 bg-light border-top d-flex justify-end">
            <v-btn
              outlined
              small
              color="grey darken-1"
              class="text-capitalize px-3 rounded-lg mr-2"
              @click="cerrardialogapli"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              small
              elevation="1"
              class="text-capitalize px-4 rounded-lg font-weight-bold"
              @click="addAplicacion()"
            >
              <v-icon left small>mdi-plus</v-icon>
              Agregar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { notif } from "@/plugins/notyf";
import global from "@/global";

export default {
  props: ["dialog", "Item", "ItemsAplicacion"],
  data() {
    return {
      valid: false,
      loading: false,
      mensaje: "",
      verAlerta: false,
      modal_aplicacion: false,
      dialogaplicacion: false,
      aplicacion: "",
      mostrarLabelDuplicado: false,
      aplicacion_ofi: "",
      global: global,
    };
  },
  computed: {
    ...mapState("navigation", ["Permisos"]),
    ...mapState("aplicacion", ["Resultados"]),
    isNuevo() {
      return !this.Item || this.Item.id == null || this.Item.id === "";
    },
  },
  mounted() {
    this.aplicacion_ofi = this.Item.aplicacion;
  },
  methods: {
    ...mapActions("aplicacion", [
      "agregarAplicacion",
      "cargarAplicacion",
      "agregarAplicacionNombre",
      "cargarAplicacionCMB",
    ]),

    async agregar() {
      if (this.$refs.form && !this.$refs.form.validate()) {
        return;
      }
      this.loading = true;
      try {
        await this.agregarAplicacion(this.Item);
        this.cerrarDialogo(true);
      } catch (error) {
        this.loading = false;
        console.error("Error al guardar aplicación:", error);
      }
    },

    cerrarDialogo(valor = false) {
      if (valor === true) {
        this.cargarAplicacion();
        notif.success(
          this.isNuevo
            ? "Aplicación registrada con éxito"
            : "Aplicación actualizada con éxito",
        );
      }
      this.loading = false;
      this.$emit("closeDialog");
    },

    abrirdialogapli() {
      this.mostrarLabelDuplicado = false;
      this.aplicacion = "";
      this.modal_aplicacion = true;
      this.dialogaplicacion = true;
    },

    cerrardialogapli() {
      this.modal_aplicacion = false;
      this.dialogaplicacion = false;
      this.aplicacion = "";
      this.mostrarLabelDuplicado = false;
    },

    async addAplicacion() {
      if (this.$refs.formaplicacion && !this.$refs.formaplicacion.validate()) {
        return;
      }
      await this.agregarAplicacionNombre({ aplicacion: this.aplicacion });
      if (this.Resultados === "error") {
        notif.error("Aplicación Duplicada");
        this.mostrarLabelDuplicado = true;
      } else {
        notif.success("Aplicación creada exitosamente");
        if (this.Item.id == null) {
          this.cargarAplicacionCMB();
        } else {
          this.cargarAplicacionCMB(this.aplicacion_ofi);
        }
        this.cerrardialogapli();
      }
    },

    dariniproxreen(e) {
      if (e !== "" && !isNaN(e)) {
        this.Item.ini_prox_reencauche = parseInt(e, 10) + 1;
      }
    },

    validarreglas() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },

    darvalordesg_irre_2(e) {
      if (e !== "" && !isNaN(e)) {
        this.Item.desg_irregular_2 = parseFloat(e) * -1;
      }
    },
  },
};
</script>

<style scoped>
/* Toolbar Header Responsive */
.table-header-toolbar {
  min-height: 56px;
}

.table-header-toolbar ::v-deep .v-toolbar__content {
  padding: 8px 14px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-main-info {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
}

.header-icon-box {
  width: 38px;
  height: 38px;
  min-width: 38px;
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-text-block {
  min-width: 0;
  overflow: hidden;
}

.header-company-title {
  font-size: 1.1rem;
  line-height: 1.25;
  letter-spacing: 0.3px;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-count-chip {
  font-size: 0.85rem !important;
  height: 28px !important;
}

.section-title {
  border-left: 3px solid #424242;
  padding-left: 8px;
  margin-bottom: 12px;
}

.bg-light {
  background-color: #f8fafc;
}

.border-top {
  border-top: 1px solid #e2e8f0;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

.btn-append-action {
  width: 38px !important;
  min-width: 38px !important;
  max-width: 38px !important;
  height: 38px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-append-action ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-append-action ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 30px;
    height: 30px;
    min-width: 30px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.85rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.7rem !important;
    height: 22px !important;
    padding: 0 5px !important;
  }

  .header-count-chip .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
    padding: 12px 14px !important;
  }

  .form-card-actions ::v-deep .v-btn,
  .form-card-actions .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-card-actions ::v-deep .v-btn + .v-btn {
    margin-left: 0 !important;
  }
}
</style>
